import { all, put,call, takeLatest, takeEvery } from 'redux-saga/effects';
import { showLoading, hideLoading } from '../../actions/Login/action';
import * as constants from '../../utils/constants';
import { GetManageCardData } from '../../actions/manage/action';
import { ManageCardData } from '../../utils/mock_Data';
import {
  getManageCapaityList,
  addManageCapacity,
  removeManageCapacity,
  updateManageCapacity,
  getManageCapaityListWithLoadCount,
  getManageCapacityLoads
} from './ManageCapacitySaga';
import {
  getManageUsersList,
  validateUser,
  addUser,
  transferUser,
  updateUser,
  confirmTransfer,
  removeUser,
  reSendInvite
} from './ManageUserSaga';
import { loadCarrierData } from './ManageCarrierSaga';
import { DomainConverter } from '../../utils/common';
import request from '../../utils/request';
const APPLICATION_JSON = 'application/json';

export function* profileImg(data: any) {
  try {
    yield put(showLoading());
    yield put(hideLoading());
  } catch (e) {
    yield put(hideLoading());
  }
}

export function* ManageCardDataData() {
  try {
    yield put(showLoading());
    const repos = ManageCardData;
    yield put(GetManageCardData(repos));
    yield put(hideLoading());
  } catch (e) {
    yield put(hideLoading());
  }
}
export function* usrDeletionSaga(action: any) {
  const { query,callback } = action.payload;
  try {
    yield put(showLoading());
    const value = DomainConverter.domainToData<any>(query);
    const {data} = yield call(request, [
      'USER',
      'DELETE',
      null,
      '',
      value,
      APPLICATION_JSON
    ]);
    if(data && data.deleteMember){
      callback && callback(data.deleteMember);
    } else {
      callback && callback();
    }
    yield put(hideLoading());
  } catch (e) {
    yield put(hideLoading());
  }
}
export default function* rootSaga() {
  yield all([
    takeLatest(constants.PROFILE_IMAGE_SET, profileImg),
    takeLatest(constants.MANAGE_CARD_DATA, ManageCardDataData),
    takeLatest(constants.USER_DELETION_REQUEST, usrDeletionSaga),
    takeLatest(constants.GET_MANAGE_USERS_LIST, getManageUsersList),
    takeLatest(constants.MANAGE_USER_VALIDATE, validateUser),
    takeLatest(constants.MANAGE_USER_TRANSFER, transferUser),
    takeLatest(constants.MANAGE_USER_TRANSFER_COFIRM_REQUEST, confirmTransfer),
    takeLatest(constants.MANAGE_USER_ADD, addUser),
    takeLatest(constants.MANAGE_USER_EDIT, updateUser),
    takeLatest(constants.MANAGE_USER_REMOVE, removeUser),
    takeLatest(constants.GET_MANAGE_CAPACITY_LIST, getManageCapaityList),
    takeLatest(constants.GET_MANAGE_CAPACITY_LIST_WITH_COUNT, getManageCapaityListWithLoadCount),
    takeEvery(constants.GET_CAPACITY_LOADS, getManageCapacityLoads),
    takeLatest(constants.MANAGE_CAPACITY_ADD, addManageCapacity),
    takeLatest(constants.MANAGE_CAPACITY_REMOVE, removeManageCapacity),
    takeLatest(constants.MANAGE_CAPACITY_EDIT, updateManageCapacity),
    takeLatest(constants.CARRIER_MANAGE_DATA_REQUEST, loadCarrierData),
    takeLatest(constants.RESEND_INVITE, reSendInvite)
  ]);
}
